export default {"src":"/_next/static/media/ellipsis-vertical-icon.38de91cb.svg","height":513,"width":513};